<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-20 16:15:10
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-20 16:15:10
 * @Description: 通讯录
-->
<template>
  <div class="home-address-book">
    <!-- 首页功能模块共用组件 -->
    <func-module
      title="通讯录"
      icon="icon-tongxunlu"
      titleColor="#588ef3"
      custom
      @hanleViewAll="getAllAddressBookData"
    >
      <div class="address-book-search">
        <input
          placeholder="请输入你想要搜索的关键字"
          v-model="keyword"
          @keyup.enter="handleSearchClick"
        />
        <button @click="handleSearchClick">搜索</button>
      </div>
    </func-module>
  </div>
</template>

<script>
import FuncModule from "@/components/common/FuncModule";
export default {
  name: "AddressBookComponent",
  components: { FuncModule },
  data() {
    return {
      keyword: ""
    };
  },
  methods: {
    getAllAddressBookData() {
      this.$router.push({ path: "/addressBook/list" });
    },
    handleSearchClick() {
      this.$router.push({
        path: "/addressBook/list",
        query: { keyword: this.keyword }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-address-book {
  .address-book-search {
    input {
      padding-left: 10px;
      width: calc(100% - 50px);
      height: 32px;
      border-style: none;
      border-color: unset;
      font-size: 12px;
      background: rgb(238, 244, 251);
      outline-color: #caecf5;
      border-radius: 5px 0 0 5px;
    }
    input:focus {
      height: 30px;
    }
    button {
      width: 50px;
      height: 32px;
      border-style: none;
      border-color: unset;
      margin-left: -5px;
      background-color: #6597f4;
      border-radius: 0 5px 5px 0;
      background-image: url("/static/images/fourbackground.png");
      color: white;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/AddressBookComponent.vue